import HttpBaseService from '@/services/http/HttpBaseService'

class LocationContentService extends HttpBaseService {

  getLocation = (slug) => {
    return this.executeRequest(`/api/content/locations/${slug}`, 'GET')
  }

}

export default new LocationContentService()
